<template lang="pug">
a(:href="getLink" style="text-decoration: none;" class="inline-block w-full sm:w-1/2" @click="trackWhatsappBtnClick")
  Btn(
    type="button"
    :class="[$style.bgWhatsapp, 'ml-0 text-black70 border border-black20 hover:bg-black10']"
    size="xl"
    kind="rebrand-cta"
    :block="true"
    btn-with-padding)
    span.flex.justify-center.gap-ds-sm.items-center
      Icon(
        class="text-white"
        :size="34"
        name="i:whatsapp"
      )
      span.text-rebrandSm.text-white {{ getButtonText }}
</template>
<script lang="ts">
import { defineComponent } from "vue"
import { extractHref, getInnerText } from "~/scripts/useful-functions"

export default defineComponent({
  name: "AvWhatsappButton",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    }
  },
  computed: {
    getLink(): string {
      return extractHref(this.block.innerBlocks[0].innerHtml) || ""
    },
    getButtonText(): string {
      return getInnerText(this.block.innerBlocks[0].innerHtml) || ""
    }
  },

  methods: {
    trackWhatsappBtnClick(): void {
      this.$snowplow.trackEvent({
        category: "contact_us",
        action: "click",
        property: "whatsapp"
      })
    }
  }
})
</script>

<style module lang="css">
.bgWhatsapp {
  background-color: #25d366;
  &:hover {
    background-color: #1ea952 !important;
  }
}
</style>
